import { PERSON_ROLES, type PersonInfoResponse, type PersonRoleEnum } from '@/entities/conversations';
import { getShortName } from '@/shared/lib';

/** Сторона расшифровки, на которой стоят реплики говорящего: клиент — `incoming`, консультант — `outgoing` */
export type SpeakerSide = 'incoming' | 'outgoing';

/** Сторона реплик говорящего по его роли */
export const getRoleSide = (role: PersonRoleEnum): SpeakerSide =>
  role === PERSON_ROLES.CLIENT ? 'incoming' : 'outgoing';

type RoleLabelKey = 'common:userRoles.CLIENT' | 'common:userRoles.EMPLOYEE';

/** Ключ подписи роли говорящего */
export const getRoleLabelKey = (role: PersonRoleEnum): RoleLabelKey =>
  role === PERSON_ROLES.CLIENT ? 'common:userRoles.CLIENT' : 'common:userRoles.EMPLOYEE';

/** Участник диалога: карточка диалога отдаёт готовое `fio`, реплика расшифровки — части имени */
type Speaker = Pick<PersonInfoResponse, 'fio' | 'firstName' | 'lastName' | 'middleName' | 'role'>;

/** Имя участника: готовое `fio`, а без него — собранное из частей */
export const getSpeakerName = (speaker: Speaker): string =>
  speaker.fio || getShortName(speaker.firstName, speaker.lastName, speaker.middleName);

/**
 * Подпись участника «Имя (роль)», без известного имени — одна роль. Одна на все места, где участник
 * назван вместе с ролью, чтобы один и тот же участник везде читался одинаково.
 */
export const getSpeakerLabel = (speaker: Speaker, t: (key: RoleLabelKey) => string): string => {
  const name = getSpeakerName(speaker);
  const roleLabel = t(getRoleLabelKey(speaker.role));
  return name ? `${name} (${roleLabel})` : roleLabel;
};
